/**********************************************************
Hawaiian Macadamia Nut Services
Alexander Self
4.8.20
Tree Inventory Display: Displays data for viewing & prior to submission
**********************************************************/
import React from 'react';
import PropTypes from 'prop-types';
import moment from 'moment';
import TreeInventoryTransactionTable from './tree_inventory_transaction_table';

const propTypes = {
  user: PropTypes.object,
  data: PropTypes.object,
  formType: PropTypes.string,
  previousInventoryTransactions: PropTypes.array,
  approver: PropTypes.object,
  employees: PropTypes.array,
  editingApplication: PropTypes.bool,
  toDelete: PropTypes.bool
};

const TreeInventoryDisplay = ({ user, data, toView, formType, previousInventoryTransactions, approver, employees, toDelete, editingApplication }) => {
  let _approver = 'N/A';
  if (approver.eid) _approver = `${approver.firstName} ${approver.lastName}`;
  return (
    <div>
      <div>
        { toDelete ? <h2 className="red-text chem-app-flex">Are you sure you want to delete the following transaction?</h2> : '' }
        { editingApplication ? <span className="app-log-header blue-text">Editing Inventory Transaction</span>
          : <div>
              <span className="right"><i className="material-icons indigo-text lighten-2 medium">assignment</i></span>
              <span className="app-log-header">Inventory Transaction</span>
            </div>
        }
        
        <br />  
        <hr />
        {
          previousInventoryTransactions.length > 0 ?
            <div className="row">
              <h5 className="blue-text app-log-prev-header">Previous Transactions - { data.location === '71' ? '71 - Kau' : '72 - Keaau' }, { data.field }</h5>
              <TreeInventoryTransactionTable inventory={previousInventoryTransactions} readOnly={true} />
            </div>
          : ''
        }
        <div className="row">
          <div className="col s12">
            <h5 className="blue-text app-log-prev-header">
              { toView ? <div></div> :
                formType === 'issueOrReceiveInventory' ?
                  <span>Inventory Request</span>
                : <span>Create New Inventory Batch</span>
              }
            </h5>
            <h5>
              <span className="left">
                { data.issuedOrReceived === 'I' ?
                  <span className="label label-incomplete">Issue</span>
                  : <span className="label label-complete">Receive</span>
                }
              </span>
            </h5>
          </div>
          <div className="col s6 m3 l3 xl3 b-r">
            <strong>Date</strong>
            <p>{ moment(data.date).format("dddd, MMMM Do YYYY") }</p>
          </div>
          <div className="col s6 m3 l3 xl3 b-r">
            <strong>Location</strong>
            <p>{ data.location === '71' ? '71 - Kau' : '72 - Keaau' }</p>
          </div>
          <div className="col s6 m3 l3 xl3 b-r">
            <strong>Physical Location</strong>
            <p>{ data.field }</p>
          </div>
          <div className="col s6 m3 l3 xl3 b-r">
            <strong>Quantity</strong>
            <p>{ data.quantity }</p>
          </div>
          <div className="col s12">
            <hr />
            <br />
            <div className="divider"></div>
            <div className="section chem-app-flex">
              <p><b>Approver: </b>{ _approver }</p> <br />
              <p><b>Comments: </b>{ data.comments }</p>
            </div>
            <div className="divider"></div>
          </div>
        </div>
        <div className="row">
          <div className="col s12">

          </div>
        </div>


      </div>

    </div>
  );
}


TreeInventoryDisplay.propTypes = propTypes;
export default TreeInventoryDisplay;



/* END */



// WEBPACK FOOTER //
// ./src/cultivation/components/tree_replant/tree_inventory_display.js